var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardCloudIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twotone-closed_caption-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5101",
    "data-name": "Caminho 5101",
    d: "M0,0H36V36H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5102",
    "data-name": "Caminho 5102",
    d: "M31.4,18.03l-2.613-.219-.512-2.988C27.415,9.7,23.555,6,19.08,6c-3.519,0-6.7,2.271-8.335,5.9l-.854,1.892-1.828.219C4.613,14.445,2,17.85,2,21.933c0,4.4,3.057,7.967,6.832,7.967h22.2c2.818,0,5.124-2.689,5.124-5.975C36.16,20.838,34.077,18.229,31.4,18.03Z",
    transform: "translate(-1.08 0.201)",
    fill: "rgba(46,128,195,0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5103",
    "data-name": "Caminho 5103",
    d: "M29.025,13.437A11.363,11.363,0,0,0,18,4a11.2,11.2,0,0,0-9.975,6.312A9.234,9.234,0,0,0,0,19.625,9.2,9.2,0,0,0,9,29H28.5A7.664,7.664,0,0,0,36,21.187,7.649,7.649,0,0,0,29.025,13.437ZM28.5,25.875H9a6.127,6.127,0,0,1-6-6.25,6.121,6.121,0,0,1,5.34-6.2l1.605-.172.75-1.484A8.17,8.17,0,0,1,18,7.125a8.348,8.348,0,0,1,8.085,6.922l.45,2.344,2.3.172a4.671,4.671,0,0,1-.33,9.312Zm-8.325-12.5h-4.35v4.687H12l6,6.25,6-6.25H20.175Z",
    transform: "translate(0 1.5)",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCloudIcon);
export default __webpack_public_path__ + "static/media/card-cloud-icon.450b0de81e463adc7f8c2ef28d164373.svg";
export { ForwardRef as ReactComponent };